module.exports = __webpack_public_path__ + "images/line_friend_lp/step2-image_d05368405ca23eb24cbe25fa0a5414fd.png";